// Columns by which users can be filtered
export const FILTER_BY_FIRST_NAME = "firstName";
export const FILTER_BY_LAST_NAME = "lastName";
export const FILTER_BY_USERNAME = "username";
export const FILTER_BY_EMAIL = "email";

// It is used for filtering, but the user enters empty text first, then adds characters (the number of characters needs to be adjusted)
export const REG_EX_FILTER_FIRST_NAME = /^[a-zA-Zá-žÁ-Ž]{0,30}$/;
export const REG_EX_FILTER_LAST_NAME = /^[a-zA-Zá-žÁ-Ž]{0,50}$/;
